var NUMERIC_PREFIX_CHAR_LENGTH = 5; // e.g. _XXX_
/**
 * Removes the numeric portion from the provided enum message key.
 *
 * If the provided `prefixedKey` is undefined, we may be missing the
 * `preserveConstEnums` TSC option which allows us to reverse lookup
 * message codes.
 */
var renderHumanReadableMessageName = function (prefixedKey) { var _a; return (_a = prefixedKey === null || prefixedKey === void 0 ? void 0 : prefixedKey.substring(NUMERIC_PREFIX_CHAR_LENGTH)) !== null && _a !== void 0 ? _a : 'CONST_ENUMS_NOT_PRESERVED'; };
export { renderHumanReadableMessageName };
//# sourceMappingURL=renderHumanReadableMessageName.js.map